import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import AdditionalQuestions from '../views/AdditionalQuestions.vue'
import RegistrationComplete from '../views/RegistrationComplete.vue'
import TermsOfUse from '../views/TermsOfUse.vue'
import AdminBackoffice from '../views/AdminBackoffice.vue'
import ResetPassword from '../views/ResetPassword.vue'
import { authState, authActions } from '../store/auth'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/creator-onboarding/:userId?',
    name: 'CreatorOnboarding',
    component: AdditionalQuestions
  },
  {
    path: '/registration-complete',
    name: 'RegistrationComplete',
    component: RegistrationComplete
  },
  {
    path: '/terms-of-use',
    name: 'TermsOfUse',
    component: TermsOfUse
  },
  {
    path: '/admin-backoffice',
    name: 'AdminBackoffice',
    component: AdminBackoffice,
    meta: { 
      requiresAuth: true,
      requiresAdmin: true 
    }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Global navigation guard for authentication and admin access
router.beforeEach(async (to, from, next) => {
  // Check if route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    
    // Ensure auth state is initialized
    if (!authState.isAuthenticated && !authState.user) {
      authActions.initAuth()
    }
    
    // Check if user is authenticated
    if (!authState.isAuthenticated || !authState.token) {
      if (process.env.NODE_ENV === 'development') {
        console.log('Access denied: User not authenticated')
      }
      next({ name: 'Home' })
      return
    }
    
    // Verify token is still valid
    const isValidToken = await authActions.verifyToken()
    if (!isValidToken) {
      if (process.env.NODE_ENV === 'development') {
        console.log('Access denied: Invalid or expired token')
      }
      next({ name: 'Home' })
      return
    }
    
    // Check if route requires admin access
    if (to.matched.some(record => record.meta.requiresAdmin)) {
      const user = authState.user
      
      if (!user || user.email !== 'nancy@rendery.org') {
        if (process.env.NODE_ENV === 'development') {
          console.log('Access denied: Admin privileges required')
        }
        next({ name: 'Home' })
        return
      }
    }
  }
  
  // Continue to route
  next()
})

export default router 